export const RPA_RECORDER_RESUME_POLLING_EVENT = 'rpa-recorder:resume-persisted-polling';
